/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Credentials_Modal_Delete_DescriptionInputs */

const es_components_credentials_modal_delete_description = /** @type {(inputs: Components_Credentials_Modal_Delete_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al eliminar esta credencial se perderá el acceso a la cuenta y los datos asociados. Esta acción no se puede deshacer.`)
};

const en_components_credentials_modal_delete_description = /** @type {(inputs: Components_Credentials_Modal_Delete_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting this credential will remove access to the account and associated data. This action cannot be undone.`)
};

/**
* | output |
* | --- |
* | "Deleting this credential will remove access to the account and associated data. This action cannot be undone." |
*
* @param {Components_Credentials_Modal_Delete_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_credentials_modal_delete_description = /** @type {((inputs?: Components_Credentials_Modal_Delete_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Credentials_Modal_Delete_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_credentials_modal_delete_description(inputs)
	return en_components_credentials_modal_delete_description(inputs)
});
export { components_credentials_modal_delete_description as "components.credentials.modal.delete.description" }